import { FORTEM_URIS } from '@/constants/uris'
import { FlowDashboard } from '@/pages/flow/_dashboard/page'
import { ClientPricingReportPage } from '@/pages/flow/client-pricing-report/page'
import { FlowLayout } from '@/pages/flow/layout'
import { FlowPosmonPage } from '@/pages/flow/posmon/page'
import { PricingInterfacePage } from '@/pages/flow/pricing-interface/page'
import { PricingMatrixPage } from '@/pages/flow/pricing-matrix/page'
import { FlowRFQPage } from '@/pages/flow/rfq/page'
import { FlowWebsitePage } from '@/pages/flow/website/page'
import type { CustomRouteObject, FortemRouteHandle } from '@/router'

export const flowRoutes = [
  {
    path: FORTEM_URIS.FLOW.__INDEX__,
    element: <FlowLayout />,
    handle: {
      title: 'Flow',
    },
    children: [
      {
        index: true,
        element: <FlowDashboard />,
      },
      {
        path: FORTEM_URIS.FLOW.POSMON,
        element: <FlowPosmonPage />,
      },
      {
        path: FORTEM_URIS.FLOW.WEBSITE,
        element: <FlowWebsitePage />,
      },
      {
        path: FORTEM_URIS.FLOW.RFQ,
        element: <FlowRFQPage />,
      },
      {
        path: FORTEM_URIS.FLOW.PRICING_MATRIX,
        element: <PricingMatrixPage />,
      },
      {
        path: FORTEM_URIS.FLOW.CLIENT_PRICING_REPORT,
        element: <ClientPricingReportPage />,
      },
      {
        path: FORTEM_URIS.FLOW.PRICING_INTERFACE,
        element: <PricingInterfacePage />,
      },
    ],
  },
] satisfies CustomRouteObject<FortemRouteHandle>[]
